module.exports = __webpack_public_path__ + "bg1.059c68202630ae9eda54.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/pages/img/frontend-slider/bg1.jpg
// module id = ../../../../../src/assets/pages/img/frontend-slider/bg1.jpg
// module chunks = styles